var scope_0 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/478e6ac5c2926712d2549fbf534b6ccb.js').default;
var scope_1 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/514e2801b541c0a7536c92414a494083.js').default;
var scope_2 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9761ff79792ab392f9168f6099a5d557.js').default;
var scope_3 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    